export const createContestsEditionStageTablesRequests = (client) => ({
    listContestsEditionStageTables: async (params) => {
        const { data, meta, links } = await client.api.get("contests_edition_stage_tables", {
            params: params,
        });
        return { data, meta, links };
    },
    getContestsEditionStageTable: async (id, params) => {
        const { data } = await client.api.get(`contests_edition_stage_tables/${id}`, {
            params: params,
        });
        return { data };
    },
    createContestsEditionStageTable: async (payload) => {
        const { data } = await client.api.create("contests_edition_stage_tables", payload);
        return { data };
    },
    updateContestsEditionStageTable: async (payload) => {
        const { data } = await client.api.update("contests_edition_stage_tables", payload);
        return { data };
    },
    deleteContestsEditionStageTable: async (id) => {
        return client.api.remove("contests_edition_stage_tables", id);
    },
});
//# sourceMappingURL=index.js.map